import { Controller } from "@hotwired/stimulus"
// A <video> that stands in for a provider's embed. Two jobs the embed did for
// free:
//
//  - **It starts.** Browsers only autoplay with sound when a user gesture
//    carries over, and a Turbo frame swap (the Pulse modal) carries none. So:
//    try with sound, and on refusal play muted — the controls are right there
//    to turn it back on.
//  - **It fits.** A file has no shape until its metadata lands, so the markup
//    holds a placeholder ratio and this swaps in the real one the moment it is
//    known. Without it every video that is not exactly the placeholder's shape
//    sits between black bars.
export default class extends Controller {
  connect() {
    const video = this.element
    this.onMeta = () => {
      if (video.videoWidth && video.videoHeight) video.style.aspectRatio = `${video.videoWidth} / ${video.videoHeight}`
    }
    video.addEventListener("loadedmetadata", this.onMeta)
    this.onMeta()
    video.play().catch(() => {
      video.muted = true
      video.play().catch(() => {})
    })
  }

  disconnect() { this.element.removeEventListener("loadedmetadata", this.onMeta) }
}
